window.FidelloAI = (function () {
  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  // Zet platte AI-tekst om naar veilige HTML: klikbare producten/categorieën,
  // vetgedrukte tekst, klikbare links, met behoud van regeleinden.
  function renderAnswer(text, products, collections) {
    let html = escapeHtml(text || "");

    // Losse URL's eerst klikbaar maken (het model typt er soms toch een uit,
    // ondanks de instructie dat niet te doen) — dit MOET vóór de naam-linkification
    // hieronder, anders kan die regex een al ingevoegde <a href="..."> kapotmaken
    // door een tweede link te beginnen middenin het href-attribuut.
    html = html.replace(/(https?:\/\/[^\s<>"']+)/g, function (url) {
      return '<a href="' + url + '" style="color:#5e918b;font-weight:600;text-decoration:underline;">' + url + "</a>";
    });

    var entities = []
      .concat((products || []).filter(function (p) { return p.matchedText && p.handle; })
        .map(function (p) { return { matchedText: p.matchedText, href: "/products/" + p.handle }; }))
      .concat((collections || []).filter(function (c) { return c.matchedText && c.url; })
        .map(function (c) { return { matchedText: c.matchedText, href: c.url }; }));

    // Langste naam eerst, en telkens alleen de eerste (nog niet gelinkte)
    // match vervangen — voorkomt dubbele/geneste links bij sterk gelijkende namen.
    entities.sort(function (a, b) { return b.matchedText.length - a.matchedText.length; });

    entities.forEach(function (e) {
      var needle = escapeHtml(e.matchedText);
      var idx = html.indexOf(needle);
      if (idx === -1) return;
      var link = '<a href="' + e.href + '" style="color:#5e918b;font-weight:600;text-decoration:underline;">' + needle + "</a>";
      html = html.slice(0, idx) + link + html.slice(idx + needle.length);
    });

    // Restant **vet** alsnog omzetten (voor het geval het model het toch gebruikt)
    html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

    return html.replace(/\n/g, "<br>");
  }

  return { renderAnswer: renderAnswer, escapeHtml: escapeHtml };
})();
